module.exports = __webpack_public_path__ + "static/media/map.722c0885.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/icons/map.svg
// module id = 965
// module chunks = 0